import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { Turnstile } from "@marsidev/react-turnstile";
import './Register.css';
import { Helmet } from "react-helmet-async";
import { GoogleLogin } from "@react-oauth/google";

function Register() {
 const [formData, setFormData] = useState({
  username: "",
  email: "",
  password: "",
  confirmPassword: ""
 });

 const [localLoading, setLocalLoading] = useState(false);
 const [errorMessage, setErrorMessage] = useState("");
 const [turnstileToken, setTurnstileToken] = useState("");

 const location = useLocation();
 const returnTo = location.state?.returnTo || "/directory";

 const navigate = useNavigate();
 const { createUser, googleLogin, isAuthenticated, loading, user } = useAuth();

 const hostname = window.location.hostname.replace(/^www\./, '');
 const mainDomain = "sportinghip.com";
 const isCustomDomain = hostname !== mainDomain;
 const slug = !isCustomDomain ? location.pathname.split("/")[1] : null;
 const domain = isCustomDomain ? hostname : null;

 useEffect(() => {
  if (!loading && isAuthenticated) {
   navigate("/directory", { replace: true });
  }
 }, [isAuthenticated, loading, navigate]);

 const handleInput = (e) => {
  const { name, value } = e.target;
  setFormData(prev => ({ ...prev, [name]: value }));
 };

 const handleRegister = async (e) => {
  e.preventDefault();

  if (formData.password !== formData.confirmPassword) {
   setErrorMessage("Passwords do not match");
   return;
  }

  if (!turnstileToken) {
   setErrorMessage("Please complete the security check.");
   return;
  }

  setLocalLoading(true);
  setErrorMessage("");

  const payload = {
   username: formData.username,
   password: formData.password,
   turnstileToken,
  };

  payload.email = formData.email.trim();

  if (domain) payload.domain = domain;
  if (slug) payload.slug = slug;

  const response = await createUser(payload);

  if (!response.success) {
   setErrorMessage(response.message);
   setLocalLoading(false);
   return;
  }

  navigate("/login", {
   state: {
    message: "Account created. Please check your email to verify your account. If you don't see it, check your Spam or Junk folder."
   },
   replace: true
  });

  setLocalLoading(false);
 };

 if (loading) return null;

 return (
  <div className="register_container">
   <Helmet>
    <title>Register | SportingHip</title>
    <meta name="robots" content="noindex,nofollow" />
   </Helmet>
   <div className="register_form_container">
    <h3 className="register_form_container_title">Create Account</h3>

    <form onSubmit={handleRegister} className="register_form">

     <label className="register_form_label">
      Username
      <input
       type='text'
       name='username'
       autoComplete='off'
       value={formData.username}
       onChange={handleInput}
       placeholder="👤  Choose a username"
      />
     </label>

     <label className="register_form_label">
      Email
      <input
       type="email"
       name="email"
       autoComplete='off'
       value={formData.email}
       onChange={handleInput}
       placeholder="📧  Enter your email"
       required
      />
     </label>

     <label className="register_form_label">
      Password
      <input
       type='password'
       name='password'
       value={formData.password}
       onChange={handleInput}
       placeholder="🔒  Create a password"
      />
     </label>

     <label className="register_form_label">
      Confirm Password
      <input
       type='password'
       name='confirmPassword'
       value={formData.confirmPassword}
       onChange={handleInput}
       placeholder="🔒  Confirm password"
      />
     </label>

     <div style={{ marginTop: "1rem", marginBottom: "1rem" }}>
      <Turnstile
       siteKey={import.meta.env.VITE_TURNSTILE_SITE_KEY}
       
       onSuccess={(token) => {
        setTurnstileToken(token);
        setErrorMessage("");
       }}
       onExpire={() => {
        setTurnstileToken("");
       }}
       onError={() => {
        setTurnstileToken("");
        setErrorMessage("Security check failed. Please try again.");
       }}
      />
     </div>

     <button
      className="register_form_btn"
      type='submit'
      disabled={localLoading}
     >
      {localLoading ? "Creating..." : "CREATE ACCOUNT"}
     </button>

     <div className="google-create-account-div" >
      Create your account with Google
     </div>

     <div style={{ marginTop: "1rem", display: "flex", justifyContent: "center" }}>
      <GoogleLogin
       onSuccess={async (credentialResponse) => {
        setLocalLoading(true);
        setErrorMessage("");

        const response = await googleLogin(credentialResponse.credential);

        if (!response.success) {
         setErrorMessage(response.message);
        }

        setLocalLoading(false);
       }}
       onError={() => {
        setErrorMessage("Google sign-in failed.");
       }}
      />
     </div>
     
     <div style={{ marginTop: "1.5rem" }}>
      <span>Already have an account? </span>
      <button
       type="button"
       className="register_form_login_btn"
       onClick={() => navigate("/login")}
      >
       Log in
      </button>
     </div>

    </form>

    {errorMessage && (
     <p style={{ color: "red", marginTop: "1rem" }}>
      {errorMessage}
     </p>
    )}

   </div>
  </div>
 );
}

export default Register;